// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__9v2ft","modal":"Modal_modal__ERobW","header":"Modal_header__3j2Gq","content":"Modal_content__DjuBi","actions":"Modal_actions__lB6bR"};